var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { Map, fromJS, List } from 'immutable';
import { Layer, Vertex, Group, Line, Item } from './export';
import { IDBroker, NameGenerator, SnapSceneUtils, SnapUtils, GeometryUtils } from '../utils/export';

import { MODE_IDLE, MODE_DRAWING_AREA, MODE_DRAGGING_AREA } from '../constants';

var Area = function () {
    function Area() {
        _classCallCheck(this, Area);
    }

    _createClass(Area, null, [{
        key: 'add',
        value: function add(state, layerID, type, verticesCoords, catalog) {

            var area = void 0;

            var layer = state.getIn(['scene', 'layers', layerID]);

            layer = layer.withMutations(function (layer) {
                var areaID = IDBroker.acquireID();

                var allLines = state.getIn(['scene', 'layers', layerID, 'lines']);
                var lines = [];

                var vertices = verticesCoords.map(function (v) {
                    return Vertex.add(state, layerID, v.x, v.y, 'areas', areaID).vertex.id;
                });

                vertices.forEach(function (vertexId) {
                    allLines.forEach(function (l) {
                        if (l.vertices.includes(vertexId)) {
                            if (!lines.includes(l.id)) lines.push(l.id);
                        };
                    });
                });

                area = catalog.factoryElement(type, {
                    id: areaID,
                    name: NameGenerator.generateName('areas', catalog.getIn(['elements', type, 'info', 'title'])),
                    type: type,
                    prototype: 'areas',
                    vertices: vertices,
                    lines: lines,
                    floorID: state.getIn(['scene', 'selectedFloor'])
                });

                layer.setIn(['areas', areaID], area);
            });

            state = state.setIn(['scene', 'layers', layerID], layer);

            return { updatedState: state, area: area };
        }
    }, {
        key: 'select',
        value: function select(state, layerID, areaID) {
            state = Layer.select(state, layerID).updatedState;
            state = Layer.selectElement(state, layerID, 'areas', areaID).updatedState;

            return { updatedState: state };
        }
    }, {
        key: 'remove',
        value: function remove(state, layerID, areaID) {

            var area = state.getIn(['scene', 'layers', layerID, 'areas', areaID]);

            if (area.get('selected') === true) state = this.unselect(state, layerID, areaID).updatedState;

            area.vertices.forEach(function (vertexID) {
                state = Vertex.remove(state, layerID, vertexID, 'areas', areaID).updatedState;
            });

            state = state.deleteIn(['scene', 'layers', layerID, 'areas', areaID]);

            state.getIn(['scene', 'groups']).forEach(function (group) {
                return state = Group.removeElement(state, group.id, layerID, 'areas', areaID).updatedState;
            });

            return { updatedState: state };
        }
    }, {
        key: 'removeWithLines',
        value: function removeWithLines(state, layerID, areaID) {

            var area = state.getIn(['scene', 'layers', layerID, 'areas', areaID]);

            if (area.get('selected') === true) state = this.unselect(state, layerID, areaID).updatedState;

            var lines = state.getIn(['scene', 'layers', layerID, 'lines']);

            lines.forEach(function (line) {
                if (area.vertices.includes(line.vertices.get(0)) && area.vertices.includes(line.vertices.get(1))) {
                    state = Line.remove(state, layerID, line.id).updatedState;
                }
            });

            state = state.deleteIn(['scene', 'layers', layerID, 'areas', areaID]);

            state.getIn(['scene', 'groups']).forEach(function (group) {
                return state = Group.removeElement(state, group.id, layerID, 'areas', areaID).updatedState;
            });

            return { updatedState: state };
        }
    }, {
        key: 'updateAreaLines',
        value: function updateAreaLines(state, layerID) {

            var areas = state.getIn(['scene', 'layers', layerID, 'areas']);
            var allLines = state.getIn(['scene', 'layers', layerID, 'lines']);

            areas.forEach(function (area) {
                var areaLines = [];

                state = state.setIn(['scene', 'layers', layerID, 'areas', area.id, 'lines'], areaLines);

                allLines.forEach(function (line) {
                    if (area.vertices.includes(line.vertices.get(0)) && area.vertices.includes(line.vertices.get(1))) {
                        areaLines.push(line.id);
                    }
                });

                state = state.setIn(['scene', 'layers', layerID, 'areas', area.id, 'lines'], areaLines);
            });

            return { updatedState: state };
        }
    }, {
        key: 'unselect',
        value: function unselect(state, layerID, areaID) {
            state = Layer.unselect(state, layerID, 'areas', areaID).updatedState;

            return { updatedState: state };
        }
    }, {
        key: 'setProperties',
        value: function setProperties(state, layerID, areaID, properties) {
            var area = state.getIn(['scene', 'layers', layerID, 'areas', areaID]).toJS();

            if (properties.get('is_balcony') !== area.properties.is_balcony) {
                (function () {
                    var areasRaw = state.getIn(['scene', 'layers', layerID, 'areas']);
                    var areas = [];
                    areasRaw.forEach(function (area) {
                        areas.push(area.toObject());
                    });

                    var linesRaw = state.getIn(['scene', 'layers', layerID, 'lines']);
                    var lines = [];
                    linesRaw.forEach(function (line) {
                        lines.push(line.toObject());
                    });

                    var linesToUpdate = [];

                    var _loop = function _loop(i) {
                        var vertice = area.vertices[i];

                        var verticesAreas = 0;

                        // finds in how many areas vertice is
                        areas.forEach(function (area) {
                            if (area.vertices.includes(vertice)) {
                                verticesAreas++;
                            }
                        });

                        // if vertice is in more than one area -> continue
                        if (verticesAreas > 1) {
                            return 'continue';
                        }

                        lines.forEach(function (line) {
                            var lineVertices = line.vertices.toArray();
                            if (lineVertices.includes(vertice)) {
                                if (linesToUpdate.filter(function (e) {
                                    return e.id === line.id;
                                }).length === 0) {
                                    linesToUpdate.push(line);
                                }
                            }
                        });
                    };

                    for (var i = 0; i < area.vertices.length; i++) {
                        var _ret2 = _loop(i);

                        if (_ret2 === 'continue') continue;
                    }

                    var isBalcony = properties.get('is_balcony') ? true : false;
                    var thicknessLength = isBalcony ? 1 : 20;
                    var textureA = isBalcony ? 'painted' : 'bricks';
                    var textureB = isBalcony ? 'painted' : 'bricks';
                    var wallHeight = isBalcony ? 80 : 300;

                    for (var i = 0; i < linesToUpdate.length; i++) {
                        var _state = state,
                            scene = _state.scene;

                        var lineId = linesToUpdate[i].id;
                        var line = state.getIn(['scene', 'layers', layerID, 'lines', lineId]);

                        var _properties = line.get('properties');
                        var thickness = _properties.get('thickness');
                        var height = _properties.get('height');
                        //let length = thickness.get('length');

                        length = thicknessLength;
                        thickness = thickness.merge({ length: length });
                        _properties = _properties.merge({ thickness: thickness });

                        length = wallHeight;
                        height = height.merge({ length: length });
                        _properties = _properties.merge({ height: height });

                        _properties = _properties.merge({ textureA: textureA });
                        _properties = _properties.merge({ textureB: textureB });

                        line = line.merge({ properties: _properties });

                        state = state.merge({
                            scene: scene.mergeIn(['layers', layerID, 'lines', lineId], line)
                        });

                        state = state.mergeIn(['scene', 'layers', layerID, 'lines', lineId, 'isBalcony'], isBalcony);
                    }
                })();
            }

            state = state.mergeIn(['scene', 'layers', layerID, 'areas', areaID, 'properties'], properties);

            return { updatedState: state };
        }
    }, {
        key: 'setJsProperties',
        value: function setJsProperties(state, layerID, areaID, properties) {
            return this.setProperties(state, layerID, areaID, fromJS(properties));
        }
    }, {
        key: 'updateProperties',
        value: function updateProperties(state, layerID, areaID, properties) {
            properties.forEach(function (v, k) {
                if (state.hasIn(['scene', 'layers', layerID, 'areas', areaID, 'properties', k])) state = state.mergeIn(['scene', 'layers', layerID, 'areas', areaID, 'properties', k], v);
            });

            return { updatedState: state };
        }
    }, {
        key: 'updateJsProperties',
        value: function updateJsProperties(state, layerID, areaID, properties) {
            return this.updateProperties(state, layerID, areaID, fromJS(properties));
        }
    }, {
        key: 'setAttributes',
        value: function setAttributes(state, layerID, areaID, attributes) {
            state = state.mergeIn(['scene', 'layers', layerID, 'areas', areaID], attributes);
            return { updatedState: state };
        }
    }, {
        key: 'selectToolDrawingArea',
        value: function selectToolDrawingArea(state, sceneComponentType) {
            state = state.merge({
                mode: MODE_DRAWING_AREA,
                drawingSupport: new Map({
                    type: sceneComponentType
                })
            });

            return { updatedState: state };
        }
    }, {
        key: 'updateDrawingArea',
        value: function updateDrawingArea(state, layerID, x, y) {

            if (state.hasIn(['drawingSupport', 'currentID'])) {
                state = this.moveArea(state, layerID, state.getIn(['drawingSupport', 'currentID']), x, y).updatedState;
            } else {
                state = Layer.unselectAll(state, layerID).updatedState;

                var _drawArea = this.drawArea(state, layerID, x, y),
                    stateI = _drawArea.updatedState,
                    area = _drawArea.area;

                state = Area.select(stateI, layerID, area.id).updatedState;
                state = state.setIn(['drawingSupport', 'currentID'], area.id);
                state = state.setIn(['drawingSupport', 'startPointX'], x);
                state = state.setIn(['drawingSupport', 'startPointY'], y);

                var snapElements = SnapSceneUtils.sceneSnapElements(state.scene, new List(), state.snapMask);
                state = state.merge({
                    mode: MODE_DRAWING_AREA,
                    snapElements: snapElements
                });

                var areaVertexIDs = state.getIn(['scene', 'layers', layerID, 'areas', area.id, 'vertices']);
                areaVertexIDs.forEach(function (vertexId) {
                    var currentVertex = state.getIn(['scene', 'layers', layerID, 'vertices', vertexId]);
                    var currentIndex = areaVertexIDs.indexOf(vertexId);

                    state = state.setIn(['drawingSupport', 'startVertexX' + currentIndex], currentVertex.x);
                    state = state.setIn(['drawingSupport', 'startVertexY' + currentIndex], currentVertex.y);
                });
            }

            return { updatedState: state };
        }
    }, {
        key: 'moveArea',
        value: function moveArea(state, layerID, areaID, x, y) {
            var _state2 = state,
                drawingSupport = _state2.drawingSupport;

            var diffX = x - drawingSupport.get('startPointX');
            var diffY = y - drawingSupport.get('startPointY');
            var areaVertexIDs = state.getIn(['scene', 'layers', layerID, 'areas', areaID, 'vertices']);

            state = state.merge({
                scene: state.scene.updateIn(['layers', layerID], function (layer) {
                    return layer.withMutations(function (layer) {
                        areaVertexIDs.forEach(function (vID) {

                            var currentIndex = areaVertexIDs.indexOf(vID);
                            var newX = drawingSupport.get('startVertexX' + currentIndex) + diffX;
                            var newY = drawingSupport.get('startVertexY' + currentIndex) + diffY;

                            layer.updateIn(['vertices', vID], function (vertex) {
                                return vertex.merge({ x: newX, y: newY });
                            });
                        });

                        return layer;
                    });
                })
            });

            return { updatedState: state };
        }
    }, {
        key: 'endDrawingArea',
        value: function endDrawingArea(state, layerID, x, y) {

            state = Layer.unselectAll(state, layerID).updatedState;

            state = state.merge({
                mode: MODE_IDLE,
                drawingSupport: null,
                activeSnapElement: null,
                snapElements: new List()
            });

            return { updatedState: state };
        }
    }, {
        key: 'drawArea',
        value: function drawArea(state, layerID, x, y) {

            var areaType = state.getIn(['drawingSupport', 'type']);
            var returnArea = void 0;

            switch (areaType) {
                case 'area':
                    var _drawRectShapeArea = this.drawRectShapeArea(state, layerID, x, y),
                        currentStateA = _drawRectShapeArea.updatedState,
                        currentAreaA = _drawRectShapeArea.area;

                    state = currentStateA;
                    returnArea = currentAreaA;
                    break;
                case 'area-square':
                    var _drawSquareShapeArea = this.drawSquareShapeArea(state, layerID, x, y),
                        currentStateB = _drawSquareShapeArea.updatedState,
                        currentAreaB = _drawSquareShapeArea.area;

                    state = currentStateB;
                    returnArea = currentAreaB;
                    break;
                case 'area-l':
                    var _drawLShapeArea = this.drawLShapeArea(state, layerID, x, y),
                        currentStateC = _drawLShapeArea.updatedState,
                        currentAreaC = _drawLShapeArea.area;

                    state = currentStateC;
                    returnArea = currentAreaC;
                    break;
                case 'area-t':
                    var _drawTShapeArea = this.drawTShapeArea(state, layerID, x, y),
                        currentStateD = _drawTShapeArea.updatedState,
                        currentAreaD = _drawTShapeArea.area;

                    state = currentStateD;
                    returnArea = currentAreaD;
                    break;
                case 'area-u':
                    var _drawUShapeArea = this.drawUShapeArea(state, layerID, x, y),
                        currentStateE = _drawUShapeArea.updatedState,
                        currentAreaE = _drawUShapeArea.area;

                    state = currentStateE;
                    returnArea = currentAreaE;
                    break;
                default:
                    state = state;
            }

            state = Layer.unselectAll(state, layerID).updatedState;

            return { updatedState: state, area: returnArea };
        }
    }, {
        key: 'drawRectShapeArea',
        value: function drawRectShapeArea(state, layerID, x, y) {

            var pointsA = [{ x: x, y: y }, { x: x, y: y - 300 }];
            var lineA = Line.addFromPoints(state, layerID, 'wall', pointsA);

            var pointsB = [pointsA[1], { x: pointsA[1].x + 500, y: pointsA[1].y }];
            var lineB = Line.addFromPoints(lineA.updatedState, layerID, 'wall', pointsB);

            var pointsC = [pointsB[1], { x: pointsB[1].x, y: pointsB[1].y + 300 }];
            var lineC = Line.addFromPoints(lineB.updatedState, layerID, 'wall', pointsC);

            var pointsD = [pointsC[1], { x: pointsC[1].x - 500, y: pointsC[1].y }];
            var lineD = Line.addFromPoints(lineC.updatedState, layerID, 'wall', pointsD);

            var layerState = Layer.detectAndUpdateAreas(lineD.updatedState, layerID);

            return { updatedState: layerState.updatedState, area: layerState.area };
        }
    }, {
        key: 'drawTShapeArea',
        value: function drawTShapeArea(state, layerID, x, y) {

            var pointsA = [{ x: x, y: y }, { x: x, y: y - 250 }];
            var lineA = Line.addFromPoints(state, layerID, 'wall', pointsA);

            var pointsB = [pointsA[1], { x: pointsA[1].x + 125, y: pointsA[1].y }];
            var lineB = Line.addFromPoints(lineA.updatedState, layerID, 'wall', pointsB);

            var pointsC = [pointsB[1], { x: pointsB[1].x, y: pointsB[1].y - 250 }];
            var lineC = Line.addFromPoints(lineB.updatedState, layerID, 'wall', pointsC);

            var pointsD = [pointsC[1], { x: pointsC[1].x + 250, y: pointsC[1].y }];
            var lineD = Line.addFromPoints(lineC.updatedState, layerID, 'wall', pointsD);

            var pointsE = [pointsD[1], { x: pointsD[1].x, y: pointsD[1].y + 250 }];
            var lineE = Line.addFromPoints(lineD.updatedState, layerID, 'wall', pointsE);

            var pointsF = [pointsE[1], { x: pointsE[1].x + 125, y: pointsE[1].y }];
            var lineF = Line.addFromPoints(lineE.updatedState, layerID, 'wall', pointsF);

            var pointsG = [pointsF[1], { x: pointsF[1].x, y: pointsF[1].y + 250 }];
            var lineG = Line.addFromPoints(lineF.updatedState, layerID, 'wall', pointsG);

            var pointsH = [pointsG[1], { x: pointsG[1].x - 500, y: pointsG[1].y }];
            var lineH = Line.addFromPoints(lineG.updatedState, layerID, 'wall', pointsH);

            var layerState = Layer.detectAndUpdateAreas(lineH.updatedState, layerID);

            return { updatedState: layerState.updatedState, area: layerState.area };
        }
    }, {
        key: 'drawUShapeArea',
        value: function drawUShapeArea(state, layerID, x, y) {

            var pointsA = [{ x: x, y: y }, { x: x, y: y - 500 }];
            var lineA = Line.addFromPoints(state, layerID, 'wall', pointsA);

            var pointsB = [pointsA[1], { x: pointsA[1].x + 500, y: pointsA[1].y }];
            var lineB = Line.addFromPoints(lineA.updatedState, layerID, 'wall', pointsB);

            var pointsC = [pointsB[1], { x: pointsB[1].x, y: pointsB[1].y + 500 }];
            var lineC = Line.addFromPoints(lineB.updatedState, layerID, 'wall', pointsC);

            var pointsD = [pointsC[1], { x: pointsC[1].x - 225, y: pointsC[1].y }];
            var lineD = Line.addFromPoints(lineC.updatedState, layerID, 'wall', pointsD);

            var pointsE = [pointsD[1], { x: pointsD[1].x, y: pointsD[1].y - 250 }];
            var lineE = Line.addFromPoints(lineD.updatedState, layerID, 'wall', pointsE);

            var pointsF = [pointsE[1], { x: pointsE[1].x - 50, y: pointsE[1].y }];
            var lineF = Line.addFromPoints(lineE.updatedState, layerID, 'wall', pointsF);

            var pointsG = [pointsF[1], { x: pointsF[1].x, y: pointsF[1].y + 250 }];
            var lineG = Line.addFromPoints(lineF.updatedState, layerID, 'wall', pointsG);

            var pointsH = [pointsG[1], { x: pointsG[1].x - 225, y: pointsG[1].y }];
            var lineH = Line.addFromPoints(lineG.updatedState, layerID, 'wall', pointsH);

            var layerState = Layer.detectAndUpdateAreas(lineH.updatedState, layerID);

            return { updatedState: layerState.updatedState, area: layerState.area };
        }
    }, {
        key: 'drawLShapeArea',
        value: function drawLShapeArea(state, layerID, x, y) {

            var pointsA = [{ x: x, y: y }, { x: x, y: y - 500 }];
            var lineA = Line.addFromPoints(state, layerID, 'wall', pointsA);

            var pointsB = [pointsA[1], { x: pointsA[1].x + 500, y: pointsA[1].y }];
            var lineB = Line.addFromPoints(lineA.updatedState, layerID, 'wall', pointsB);

            var pointsC = [pointsB[1], { x: pointsB[1].x, y: pointsB[1].y + 250 }];
            var lineC = Line.addFromPoints(lineB.updatedState, layerID, 'wall', pointsC);

            var pointsD = [pointsC[1], { x: pointsC[1].x - 250, y: pointsC[1].y }];
            var lineD = Line.addFromPoints(lineC.updatedState, layerID, 'wall', pointsD);

            var pointsE = [pointsD[1], { x: pointsD[1].x, y: pointsD[1].y + 250 }];
            var lineE = Line.addFromPoints(lineD.updatedState, layerID, 'wall', pointsE);

            var pointsF = [pointsE[1], { x: pointsE[1].x - 250, y: pointsE[1].y }];
            var lineF = Line.addFromPoints(lineE.updatedState, layerID, 'wall', pointsF);

            var layerState = Layer.detectAndUpdateAreas(lineF.updatedState, layerID);

            return { updatedState: layerState.updatedState, area: layerState.area };
        }
    }, {
        key: 'drawSquareShapeArea',
        value: function drawSquareShapeArea(state, layerID, x, y) {

            var pointsA = [{ x: x, y: y }, { x: x, y: y - 300 }];
            var lineA = Line.addFromPoints(state, layerID, 'wall', pointsA);

            var pointsB = [pointsA[1], { x: pointsA[1].x + 300, y: pointsA[1].y }];
            var lineB = Line.addFromPoints(lineA.updatedState, layerID, 'wall', pointsB);

            var pointsC = [pointsB[1], { x: pointsB[1].x, y: pointsB[1].y + 300 }];
            var lineC = Line.addFromPoints(lineB.updatedState, layerID, 'wall', pointsC);

            var pointsD = [pointsC[1], { x: pointsC[1].x - 300, y: pointsC[1].y }];
            var lineD = Line.addFromPoints(lineC.updatedState, layerID, 'wall', pointsD);

            var layerState = Layer.detectAndUpdateAreas(lineD.updatedState, layerID);

            return { updatedState: layerState.updatedState, area: layerState.area };
        }
    }, {
        key: 'beginDraggingArea',
        value: function beginDraggingArea(state, layerID, areaID, x, y) {
            var areaVertexIDs = state.getIn(['scene', 'layers', layerID, 'areas', areaID, 'vertices']);
            var areaVertices = [];
            var polygonPointsArray = [];
            var areaItems = [];

            areaVertexIDs.forEach(function (vId) {
                var currentVertex = state.getIn(['scene', 'layers', layerID, 'vertices', vId]);
                areaVertices.push({ vertexID: currentVertex.id, originalX: currentVertex.x, originalY: currentVertex.y });
                polygonPointsArray.push(currentVertex.x);
                polygonPointsArray.push(currentVertex.y);
            });

            var items = state.getIn(['scene', 'layers', layerID, 'items']);
            if (items) {
                items.forEach(function (i) {
                    if (GeometryUtils.ContainsPoint(polygonPointsArray, i.x, i.y)) areaItems.push({ itemID: i.id, x: i.x, y: i.y });
                });
            }

            state = state.merge({
                mode: MODE_DRAGGING_AREA,
                draggingSupport: Map({
                    layerID: layerID,
                    areaID: areaID,
                    startPointX: x,
                    startPointY: y,
                    areaVertices: areaVertices,
                    areaItems: areaItems
                })
            });

            return { updatedState: state };
        }
    }, {
        key: 'updateDraggingArea',
        value: function updateDraggingArea(state, x, y) {
            var _state3 = state,
                draggingSupport = _state3.draggingSupport,
                snapElements = _state3.snapElements;


            var layerID = draggingSupport.get('layerID');
            var diffX = x - draggingSupport.get('startPointX');
            var diffY = y - draggingSupport.get('startPointY');
            var areaVertices = draggingSupport.get('areaVertices');

            state = state.merge({
                scene: state.scene.updateIn(['layers', layerID], function (layer) {
                    return layer.withMutations(function (layer) {
                        areaVertices.forEach(function (vertex) {

                            var newX = vertex.originalX + diffX;
                            var newY = vertex.originalY + diffY;

                            layer.updateIn(['vertices', vertex.vertexID], function (vertex) {
                                return vertex.merge({ x: newX, y: newY });
                            });
                        });

                        return layer;
                    });
                })
            });

            var areaItems = draggingSupport.get('areaItems');
            if (areaItems) {
                areaItems.forEach(function (i) {
                    var item = state.scene.getIn(['layers', layerID, 'items', i.itemID]);
                    item = item.merge({ x: i.x + diffX, y: i.y + diffY });

                    state = state.merge({
                        scene: state.scene.mergeIn(['layers', layerID, 'items', i.itemID], item)
                    });
                });
            }

            return { updatedState: state };
        }
    }, {
        key: 'endDraggingArea',
        value: function endDraggingArea(state, x, y) {

            // state = this.updateDraggingArea(state, x, y).updatedState;
            var _state4 = state,
                draggingSupport = _state4.draggingSupport;

            var layerID = draggingSupport.get('layerID');
            // let areaID = state.getIn(['draggingSupport', 'areaID']);
            // let areaLineIDs = state.getIn(['scene', 'layers', layerID, 'areas', areaID, 'lines']);
            // let layer = state.getIn(['scene', 'layers', layerID]);

            // areaLineIDs.forEach(lineID => {

            //   let line = state.getIn(['scene', 'layers', layerID, 'lines', lineID]);

            //   let vertex0 = layer.vertices.get(line.vertices.get(0));
            //   let vertex1 = layer.vertices.get(line.vertices.get(1));

            //   let maxV = GeometryUtils.maxVertex(vertex0, vertex1);
            //   let minV = GeometryUtils.minVertex(vertex0, vertex1);

            //   let lineLength = GeometryUtils.verticesDistance(minV, maxV);
            //   let alpha = Math.atan2(maxV.y - minV.y, maxV.x - minV.x);

            //   let holesWithOffsetPosition = [];
            //   layer.lines.get(lineID).holes.forEach(holeID => {
            //     let hole = layer.holes.get(holeID);
            //     let pointOnLine = lineLength * hole.offset;

            //     let offsetPosition = {
            //       x: pointOnLine * Math.cos(alpha) + minV.x,
            //       y: pointOnLine * Math.sin(alpha) + minV.y
            //     };

            //     holesWithOffsetPosition.push({ hole, offsetPosition });
            //   });

            //   let diffX = x - draggingSupport.get('startPointX');
            //   let diffY = y - draggingSupport.get('startPointY');

            //   let newVertex0X = vertex0.x + diffX;
            //   let newVertex0Y = vertex0.y + diffY;
            //   let newVertex1X = vertex1.x + diffX;
            //   let newVertex1Y = vertex1.y + diffY;

            //   let lineGroups = state   //get groups membership if present
            //     .getIn(['scene', 'groups'])
            //     .filter(group => {
            //       const lines = group.getIn(['elements', layerID, 'lines']);
            //       return lines && lines.contains(lineID);
            //     });

            //   state = Layer.mergeEqualsVertices(state, layerID, line.vertices.get(0)).updatedState;
            //   state = Layer.mergeEqualsVertices(state, layerID, line.vertices.get(1)).updatedState;

            //   state = Line.remove(state, layerID, lineID).updatedState;

            //   if (!GeometryUtils.samePoints({ newVertex0X, newVertex0Y }, { newVertex1X, newVertex1Y })) {
            //     let ret = Line.createAvoidingIntersections(
            //       state,
            //       layerID,
            //       line.type,
            //       newVertex0X,
            //       newVertex0Y,
            //       newVertex1X,
            //       newVertex1Y,
            //       line.properties,
            //       holesWithOffsetPosition
            //     );

            //     state = ret.updatedState;

            //     //re-add to old line's groups if present
            //     ret.lines.forEach(addedLine => {
            //       lineGroups.forEach(oldLineGroup => {
            //         state = Group.addElement(state, oldLineGroup.id, layerID, 'lines', addedLine.id).updatedState;
            //       });
            //     });
            //   }

            //   //state = Layer.detectAndUpdateAreas(state, layerID).updatedState;
            // });

            // state = Layer.detectAndUpdateAreas(state, layerID).updatedState;

            state = Layer.unselectAll(state, layerID).updatedState;

            state = state.merge({
                mode: MODE_IDLE,
                draggingSupport: null,
                activeSnapElement: null,
                snapElements: new List()
            });

            return { updatedState: state };
        }
    }]);

    return Area;
}();

export { Area as default };